import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          This will become the site for Contact Symmetry. 
        </p>
        <p>
          A new way to keep your various system's contact information in harmony.
        </p>
      </header>
    </div>
  );
}

export default App;
